import { Link } from '@on3/ui-lib/components/Link';
import { ServiceLogo } from '@on3/ui-lib/components/ServiceLogo/ServiceLogo';
import { webUrl } from '@on3/ui-lib/utils/api';
import clsx from 'clsx';

import styles from './Brands.module.scss';

export const Brands = ({
  className,
  variant,
}: {
  className?: string;
  variant?: 'default' | 'small';
}) => (
  <div
    className={clsx(
      styles.component,
      {
        [styles.small]: variant === 'small',
      },
      className,
    )}
    data-ui="brands"
  >
    <Link href={webUrl}>
      <ServiceLogo className={styles.on3} type="on3" />
    </Link>
    <div className={styles.divider} data-ui="brands-divider" />
    <Link href={`${webUrl}/rivals/`}>
      <ServiceLogo className={styles.rivals} type="rivals" />
    </Link>
  </div>
);
